import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, GridToolbar, GridColumn as Column, GridCell, GridItemChangeEvent } from '@progress/kendo-react-grid';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import * as moment from 'moment';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    data: ChildRate[];
    rates: ChildRate[];
    isLoading: boolean;
    childId: number;
}

type ChildRate = {
    ChildRateID: number;
    Description: string;
    RateType: number;
    Amount: number;
    EffectiveStartDate: Date | null;
    EffectiveEndDate: Date | null;

    // For Grid
    inEdit: boolean|undefined;
}

export default class Rates extends React.Component<Props, State> {

    CommandCell: typeof GridCell;
    RateTypeDropDownCell: typeof GridCell;

    constructor(props: Props) {
        super(props);

        this.state = {
            data: [],
            rates: [],
            isLoading: true,
            childId: 0,
        }

        this.enterInsert = this.enterInsert.bind(this);
        this.itemChange = this.itemChange.bind(this);

        const enterEdit = this.enterEdit.bind(this);
        const save = this.save.bind(this);
        const cancel = this.cancel.bind(this);
        const remove = this.remove.bind(this);

        class CommandCell extends GridCell {
            public render() {
              return !this.props.dataItem.inEdit ?
                (<td>
                  <button
                    className="k-primary k-button k-grid-edit-command"
                    onClick={(e) => enterEdit(this.props.dataItem)}
                  > Edit</button>
                  <button
                    className="k-button k-grid-remove-command"
                    onClick={(e) => confirm('Really delete?') &&
                      remove(this.props.dataItem)}
                  > Remove</button>
                    </td>
                ) : (
                  <td>
                    <button
                      className="k-button k-grid-save-command"
                      onClick={(e) => save(this.props.dataItem)}
                    > {this.props.dataItem.ChildRateID ? 'Update' : 'Add'}</button>
                    <button
                      className="k-button k-grid-cancel-command"
                      onClick={(e) => cancel(this.props.dataItem)}
                    >{this.props.dataItem.ChildRateID ? 'Cancel' : 'Discard'}</button>
                  </td>
                );
            }
          };
          this.CommandCell = CommandCell;

          class RateTypeDropDownCell extends GridCell {
            private rateTypes = [
                { text: 'Per Half Hour', value: 13 },
                { text: 'Per Hour', value: 0 },
                { text: 'Per Day', value: 1 },
                { text: 'Per Half Day', value: 2 },
                { text: 'Per Month', value: 4 },
                { text: 'Per Half Hour Discount', value: 14 },
                { text: 'Per Hour Discount', value: 5 },
                { text: 'Per Day Discount', value: 6 },
                { text: 'Per Half Day Discount', value: 7 },
                { text: 'Per Month Discount', value: 9 },
                { text: 'AM Drop-Off/Pick-Up', value: 10 },
                { text: 'PM Drop-Off/Pick-Up', value: 11 },
                { text: 'AM & PM Drop-Off/Pick Up', value: 12 }
            ]
            public render() {
                if (!this.props.field) return null;

                const value = this.props.dataItem[this.props.field];

                if (!this.props.dataItem.inEdit) {
                    return (
                        <td>
                          {(value === null) ? '' : this.typeLabel(this.props.dataItem[this.props.field])}
                        </td>
                    );
                }

                return (
                    <td>
                        <DropDownList
                            style = {{width: 240}}
                            onChange={this.handleChange.bind(this)}
                            value={this.rateTypes.find(x => x.value === value)}
                            data={this.rateTypes}
                            textField="text"
                        />
                    </td>
                );
            }

            private handleChange(e: DropDownListChangeEvent) {
                if (this.props.onChange) {
                    this.props.onChange({
                        dataItem: this.props.dataItem,
                        field: this.props.field,
                        syntheticEvent: e.syntheticEvent,
                        value: e.target.value.value
                    });
                }
            }

            private typeLabel(rateType: number) {
                switch(rateType)
                {
                    case 0:
                        return 'Per Hour';
                    case 1:
                        return 'Per Day';
                    case 2:
                        return 'Per Half Day';
                    case 3:
                        return 'Per Week';
                    case 4:
                        return 'Per Month';
                    case 5:
                        return 'Per Hour Discount';
                    case 6:
                        return 'Per Day Discount';
                    case 7:
                        return 'Per Half Day Discount';
                    case 8:
                        return 'Per Week Discount';
                    case 9:
                        return 'Per Month Discount';
                    case 10:
                        return 'AM Drop-Off/Pick-Up';
                    case 11:
                        return 'PM Drop-Off/Pick-Up';
                    case 12:
                        return 'AM & PM Drop-Off/Pick Up';
                    case 13:
                        return 'Per Half Hour';
                    case 14:
                        return 'Per Half Hour Discount';
                    default:
                        return rateType
                }
            }
          }
          this.RateTypeDropDownCell = RateTypeDropDownCell;
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestRates(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.rates && this.state.childId != childId) {
            this.requestRates(childId);
        }
    }

    public render() {
        return <React.Fragment>
            {(this.state.isLoading && <LoadingPanel />) || <div>
                <br />
                <Grid
                    data={this.state.data}
                    onItemChange={this.itemChange}
                    editField="inEdit"
                >
                    <GridToolbar>
                        <button
                            title="Add new"
                            className="k-button k-primary"
                            onClick={this.enterInsert}
                        >Add new rate
                </button>
                        {this.state.data.filter(p => p.inEdit).length > 0 && (
                            <button
                                title="Cancel current changes"
                                className="k-button"
                                onClick={(e) => {
                                    this.setState({ data: this.state.rates.slice() })
                                }}
                            >Cancel current changes
                  </button>
                        )}
                    </GridToolbar>
                    <Column field="RateType" title="Type" cell={this.RateTypeDropDownCell} />
                    <Column field="Description" editor="text" />
                    <Column field="Amount" title="Amount" editor="numeric" format="{0:c}" />
                    <Column field="EffectiveStartDate" title="Effective From" editor="date" format="{0:D}" />
                    <Column field="EffectiveEndDate" title="Effective To" editor="date" format="{0:D}" />
                    <Column cell={this.CommandCell} />
                </Grid>
                </div>
                }
        </React.Fragment>;
    }

    private enterInsert() {
        const dataItem = {
            ChildRateID: 0,
            Amount: 0,
            Description: '',
            RateType: 1,
            EffectiveStartDate: null,
            EffectiveEndDate: null,
            inEdit: true
        } as ChildRate;
        const newRates = this.state.data.slice();
        newRates.unshift(dataItem);
        this.update(newRates, dataItem);
        this.setState({
            data: newRates
        });
    }

    private enterEdit(dataItem: ChildRate) {
        this.update(this.state.data, dataItem).then((data) => {
            data.inEdit = true;

            this.setState({
                data: this.state.data.slice()
            });
        });
    }

    private save(dataItem: ChildRate) {

        if (dataItem.EffectiveStartDate === null) {
            alert("Please enter an effective start date.");
            return;
        }

        if (dataItem.EffectiveEndDate === null) {
            alert("Please enter an effective end date.");
            return;
        }

        if (dataItem.EffectiveStartDate >= dataItem.EffectiveEndDate) {
            alert("Effective end date cannot be before start date.");
            return;
        }

        dataItem.inEdit = undefined;
        this.update(this.state.rates, dataItem).then((data) => {

            if (dataItem.ChildRateID) {
                fetchApi(`api/ChildRates/Edit/${this.state.childId}`, dataItem, 'POST')
                    .then((response: { Success: boolean, ErrorMessage: string }) => {
                        if (response.Success == false) {
                            alert(response.ErrorMessage);
                        }
                    })
            }

            dataItem.ChildRateID = data.ChildRateID;

            this.setState({
                data: this.state.data.slice()
            });
        });
    }

    private requestRates(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/ChildRates/List/${childId}`)
            .then((rates: ChildRate[]) => {
                rates.map((rate, index) => {
                    rates[index].EffectiveStartDate = moment.utc(rate.EffectiveStartDate).toDate();
                    rates[index].EffectiveEndDate = moment.utc(rate.EffectiveEndDate).toDate();
                  });
                this.setState({ isLoading: false, data: rates, rates });
            });
    }

    private cancel(dataItem: ChildRate) {
        if (dataItem.ChildRateID) {
            let originalItem = this.state.rates.find(p => p.ChildRateID === dataItem.ChildRateID);
            this.update(this.state.data, originalItem as ChildRate);
        } else {
            this.update(this.state.data, dataItem, !dataItem.ChildRateID);
        }
        this.setState({
            data: this.state.data.slice()
        });
    }

    private remove(dataItem: ChildRate) {
        if (dataItem.ChildRateID) {
            fetchApi(`api/ChildRates/Delete/${dataItem.ChildRateID}`, {}, 'DELETE')
                .then(() => {
                    dataItem.inEdit = undefined;
                    this.update(this.state.rates, dataItem, true);
                    this.setState({
                        data: this.state.data.slice()
                    });
                })
                .catch(() => {
                    alert("Unknown Error Occurred!");
                });
        }
    }

    private itemChange(event: GridItemChangeEvent) {
        const value = event.value;
        const name = event.field;
        if (!name) {
            return;
        }
        const updatedData = this.state.data.slice();
        this.update(updatedData, event.dataItem).then((item) => {
            (item as any)[name] = value;
            this.setState({
                data: updatedData
            });
        });
    }

    private async update(data: ChildRate[], item: ChildRate, remove: boolean = false): Promise<ChildRate> {
        let updated;
        let index = data.findIndex((p) => p === item || item.ChildRateID !== 0 && p.ChildRateID === item.ChildRateID);
        if (index >= 0) {
            updated = Object.assign({}, item);
            data[index] = updated;
        } else {

            if (item.EffectiveStartDate === null) {
                alert("Please enter an effective start date.");
                return Promise.reject(data[index]);
            }

            if (item.EffectiveEndDate === null) {
                alert("Please enter an effective end date.");
                return Promise.reject(data[index]);
            }

            if (item.EffectiveStartDate >= item.EffectiveEndDate) {
                alert("Effective end date cannot be before start date.");
                return Promise.reject(data[index]);
            }

            if (item.Description.length > 100) {
                alert("Please enter a shorter description.");
                return Promise.reject(data[index]);
            }

            // Add new ID to state incase it's updated before reloading
            return await fetchApi(`api/ChildRates/Add/${this.state.childId}`, item, 'POST')
                .then((response: { Success: boolean, ErrorMessage: string, ChildRateID: number }) => {
                    if (response.Success) {
                        updated = Object.assign({}, item, { ChildRateID: response.ChildRateID });
                        data.unshift(updated);
                        index = 0;
                    } else {
                        alert(response.ErrorMessage)
                    }

                    return data[index];
                });
        }

        if (remove) {
            data = data.splice(index, 1);
        }

        return data[index];
    }
}
